import { render, staticRenderFns } from "./learningrecord.vue?vue&type=template&id=4967e2a0&scoped=true&"
import script from "./learningrecord.vue?vue&type=script&lang=js&"
export * from "./learningrecord.vue?vue&type=script&lang=js&"
import style0 from "./learningrecord.vue?vue&type=style&index=0&id=4967e2a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967e2a0",
  null
  
)

export default component.exports